





















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'ChartRunningWidgetVLR',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
});
